import { CheckboxList } from "../../../components";
import { useGetTagsQuery } from "../../../redux/services/tags/tagsApi";

const CUSTOMER_STATUS_OPTIONS = [
  { _id: "true", name: "Active" },
  { _id: "false", name: "Pending" },
];

export const CustomerStatusFilterList = (props) => {
  function handleChange(value) {
    if (!value || value.length === 0) {
      props.onChange({
        title: props.value?.defaultText || "",
        value: "",
      });
      return;
    }

    props.onChange({
      title: value.map(({ name }) => name).join(","),
      value: value.map(({ _id }) => _id).join(","),
    });
  }

  return (
    <CheckboxList
      onChange={handleChange}
      objectKey="_id"
      value={props.value.value}
      data={CUSTOMER_STATUS_OPTIONS}
    />
  );
};

export const CustomerTagsFilterList = (props) => {
  const { data, isLoading } = useGetTagsQuery({
    appliesTo: "customers",
    limit: 200,
  });
  const tags = data?.tags || [];

  function handleChange(value) {
    if (!value || value.length === 0) {
      props.onChange({
        title: props.value?.defaultText || "",
        value: "",
      });
      return;
    }

    props.onChange({
      title: value.map(({ name }) => name).join(","),
      value: value.map(({ _id }) => _id).join(","),
    });
  }

  return (
    <CheckboxList
      onChange={handleChange}
      objectKey="_id"
      value={props.value.value}
      data={tags}
      loading={isLoading}
    />
  );
};
